<script lang="ts" setup>
import { TTagVariant } from '@/ui/common/tag/types'
import { computed } from 'vue'

interface Props {
  variant: TTagVariant | string
  textColor?: string
  backgroundColor?: string
}

const props = defineProps<Props>()

const customStyle = computed(() => {
  const style: Record<string, string> = {}

  if (props.textColor) {
    style.color = props.textColor
  }

  if (props.backgroundColor) {
    style.backgroundColor = props.backgroundColor
  }

  return Object.keys(style).length > 0 ? style : undefined
})
</script>

<template>
  <a-tag
      :class="['tag', `tag_${props.variant}`]"
      :style="customStyle"
  >
    <slot />
  </a-tag>
</template>

<style lang="css" scoped>
.tag {
  composes: aiRobotoMedium from global;
  border: initial;
}

.tag_orange {
  color: var(--orange_text);
  background-color: var(--orange_bg);
}

.tag_blue {
  color: var(--blue_text);
  background-color: var(--blue_bg);
}

.tag_purple {
  color: var(--purple_text);
  background-color: var(--purple_bg);
}

.tag_pink {
  color: var(--pink_text);
  background-color: var(--pink_bg);
}
</style>